export default "__VITE_ASSET__xeyzT3AC__"